export default __webpack_public_path__ + "static/media/strive-footer-logo.5697b325.png";